/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ChatQuotaStatus { 
    used?: number;
    limit?: number;
    exceeded?: boolean;
    resetsAt?: Date;
    scope?: ChatQuotaStatus.ScopeEnum;
}
export namespace ChatQuotaStatus {
    export type ScopeEnum = 'ORGANISATION' | 'PERSONAL';
    export const ScopeEnum = {
        ORGANISATION: 'ORGANISATION' as ScopeEnum,
        PERSONAL: 'PERSONAL' as ScopeEnum
    };
}